// extracted by mini-css-extract-plugin
export default {"adder":"vp_EIiRZ"};